/** 샵관리 — 재고현황 (제품별 현재고·FIFO 선두단가·재고금액·안전재고 미달) */
import React from 'react';
import { hiCol } from 'components/grid/hiGrid';
import ShopGridPage from './ShopGridPage';
import { stockSummary } from 'shop/shopStore';
import { kwField, selectField, matchKeyword } from 'shop/shopPageHelpers';

const cfg = {
  gridId: 'sh-stock',
  title: '재고현황',
  uidKey: 'productUid',
  readOnly: true,
  searchDefaults: { keyword: '', low: '' },
  searchFields: () => [[kwField('코드·제품명·분류'), selectField('low', '상태', [{ value: 'Y', label: '안전재고 미달' }])]],
  columns: () => [
    hiCol.roTextColumn({ header: '제품코드', field: 'productCode', size: 110 }),
    hiCol.roTextColumn({ header: '제품명', field: 'productNm', size: 200 }),
    hiCol.roTextColumn({ header: '분류', field: 'category', size: 110 }),
    hiCol.roNumberColumn({ header: '현재고', field: 'remainQty', size: 100 }),
    hiCol.roTextColumn({ header: '단위', field: 'useUnit', size: 70, align: 'center' }),
    hiCol.roNumberColumn({ header: '안전재고', field: 'safetyQty', size: 90 }),
    hiCol.roTextColumn({ header: '상태', field: 'stateLabel', size: 100, align: 'center' }),
    hiCol.roNumberColumn({ header: '선두단가(FIFO)', field: 'headCostRound', size: 120 }),
    hiCol.roNumberColumn({ header: '평균단가', field: 'avgCostRound', size: 100 }),
    hiCol.roNumberColumn({ header: '재고금액', field: 'stockAmount', size: 110 }),
    hiCol.roNumberColumn({ header: '입고건수', field: 'lotCount', size: 80 }),
    hiCol.roTextColumn({ header: '최근 유통기한', field: 'nearExpiry', size: 120, align: 'center' }),
  ],
  load: (tc) => stockSummary(tc).filter((s) => s.useYn !== 'N').map((s) => ({
    ...s,
    mod: '',
    headCostRound: Math.round(s.headCost),
    avgCostRound: Math.round(s.avgCost),
    stateLabel: s.lowStock ? '⚠ 부족' : '정상',
  })),
  filter: (rows, v) => rows.filter(
    (r) => (v.low !== 'Y' || r.lowStock) && matchKeyword(r, ['productCode', 'productNm', 'category'], v.keyword)
  ),
};

const StockStatus = () => <ShopGridPage cfg={cfg} />;
export default StockStatus;
